export function weatherCodeLabel(code?: number | null): string {
  if (code == null) return 'Forecast';
  if (code === 0) return 'Clear';
  if (code <= 3) return 'Partly cloudy';
  if (code <= 48) return 'Fog';
  if (code <= 67) return 'Rain';
  if (code <= 77) return 'Snow';
  if (code <= 82) return 'Showers';
  if (code <= 86) return 'Snow showers';
  return 'Thunderstorm';
}

export function weekdayLong(period: string): string {
  const d = new Date(`${period}T12:00:00`);
  if (Number.isNaN(d.getTime())) return period;
  return d.toLocaleDateString(undefined, { weekday: 'long' });
}

export function weekdayShort(period: string): string {
  const d = new Date(`${period}T12:00:00`);
  if (Number.isNaN(d.getTime())) return period;
  return d.toLocaleDateString(undefined, { weekday: 'short' });
}
